import React from 'react';
import './ExtraCardBehavior.css';

export default ({children}) => {
  return (
    <div className="ExtraCardBehavior">
      <div className="ExtraCardBehavior__Border">{children}</div>
    </div>
  );
};
